import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, onBeforeUnmount, getCurrentInstance } from 'vue'
import {
  AUTH_STATE_CHANGED,
  OPEN_LOGIN_DIALOG,
  emitLoginDialogClosePair,
  emitLoginSuccess,
  emitSetLoginContext,
  emitter
} from '@/plugins/emitter'
import LoginForms from '@/components/auth/LoginSpecialForms.vue'

type Hub = {
  $on: (type: string, fn: (...args: any[]) => void) => void
  $off: (type: string, fn: (...args: any[]) => void) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginDialog',
  setup(__props) {

/**
 * 共通ログインダイアログ（vue-final-modal）。
 * open / close / success / context / auth_state_changed は mitt 購読
 * （未移行 hub 発火は emitter の hub→mitt forward。firebase-lib の発火は当面 hub のまま）。
 */
const vm = getCurrentInstance()!.proxy as any
const hub = vm.$eventHub as Hub

const visible = ref(false)
const fullscreenLoading = ref(false)
const isProcessingEvent = ref(false)

function emitClosed() {
  emitLoginDialogClosePair()
}

function openLoginDialog(context?: unknown) {
  console.log('[LoginDialog openLoginDialog] コンテキスト:', context)

  if (isProcessingEvent.value) {
    console.log(
      '[LoginDialog openLoginDialog] 既に処理中のため、スキップします'
    )
    return
  }

  isProcessingEvent.value = true

  if (context) {
    emitSetLoginContext(context)
  }

  visible.value = true

  setTimeout(() => {
    isProcessingEvent.value = false
  }, 100)
}

function closeLoginDialog() {
  if (!visible.value) return
  visible.value = false
  emitClosed()
}

/** 背景クリック等で VFM が閉じたとき。closeLoginDialog 経由で既に false なら二重 emit しない */
function onVisibleInput(value: boolean) {
  if (value) {
    visible.value = true
    return
  }
  if (!visible.value) return
  visible.value = false
  emitClosed()
}

/**
 * ログイン成功: 旧 vue-js-modal hide と同様、closed を先に出してから login-success。
 * （Payment は closed、完了画面パネルは closed 時点の認証状態で abandon 判定）
 */
function handleAuthStateChanged(user: unknown) {
  console.log('handleAuthStateChanged')
  if (user) {
    console.log('login-success')
    if (visible.value) {
      visible.value = false
      emitClosed()
    }
    emitLoginSuccess()
  }
}

function onOpenLoginDialog(context?: unknown) {
  openLoginDialog(context)
}

onBeforeMount(() => {
  emitter.on(OPEN_LOGIN_DIALOG, onOpenLoginDialog)
  emitter.on(AUTH_STATE_CHANGED, handleAuthStateChanged)
  hub.$on('popstate', closeLoginDialog)
})

onBeforeUnmount(() => {
  emitter.off(OPEN_LOGIN_DIALOG, onOpenLoginDialog)
  emitter.off(AUTH_STATE_CHANGED, handleAuthStateChanged)
  hub.$off('popstate', closeLoginDialog)
})

return { __sfc: true,vm, hub, visible, fullscreenLoading, isProcessingEvent, emitClosed, openLoginDialog, closeLoginDialog, onVisibleInput, handleAuthStateChanged, onOpenLoginDialog, LoginForms }
}

})